import React, { useEffect } from 'react'
import Order_Details_Card from '../order_details_card/Order_Details_Card'
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrderDeliver } from '../../../../../features/order/orderSlice';
import { encodeId, formatDate, formatNewDate } from '../../../../../utils/common';

const Delivered = () => {

    const data = [
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Delivered (15th May. 2025)"
        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Delivered (15th May. 2025)"

        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Delivered (15th May. 2025)"

        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Delivered (15th May. 2025)"

        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Delivered (15th May. 2025)"

        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Delivered (15th May. 2025)"

        },

    ]
    const dispatch = useDispatch();

    const deliver = useSelector((state) => state.order.allOrdersDeliver);
    useEffect(() => {
        dispatch(getAllOrderDeliver({ order_status_id: [5] }));
    }, [dispatch]);

    console.log(

        deliver
    );

    return (
        <section className='Delivered Ordered'>
            {deliver?.data?.map((item) => {
                return (
                    <Order_Details_Card
                        orderId={item?.invoice_no || " "}
                        no_of_items={Number(item?.no_of_item || 0) - Number(item?.return_on_of_item || 0) - Number(item?.cancel_on_of_item || 0) || "0"}
                        date={item?.createdAt || new Date()}
                        price={item?.total_amount || "0"}
                        subtext={`${item?.Order_status?.name} at (${formatNewDate(item?.Order_History?.deliveredAt)})`}
                        // onClick={() => {
                        //     setShowCouponModal(true);
                        // }}
                        baseLike={`/delivered-order-details/${encodeId(item?.id)}`}
                        data={item}
                        // baseLike="/delivered-order-details"
                        type="delivered" />
                )
            })}

            <div className='no_data_main_div'>
                <p className='no_data_text'>No more orders to show</p>
            </div>

        </section>
    )
}

export default Delivered
